<template>
    <div class="contentFaq-wrapper">
        <v-collapse-wrapper class="panel panel-default" v-for="contentfaq in contentfaqs" v-bind:key="contentfaq.head">
            <div class="panel-heading" v-collapse-toggle @click="switchIconClass">
                <div class="panel-title">
                    <a href="#faqs-entries" class="prodbenefits">
                        <span class="title" >
                            {{ contentfaq.head }}
                        </span>
                        <i class="glyphicon glyphicon-plus"></i>
                    </a>
                </div>
            </div>
            <div class="panel-collapse" v-collapse-content>
                <div class="panel-body">
                    <div class="col-xs-12 col-sm-8 no-padding-right">
                        <div class="col-xs-12 no-padding" v-html="contentfaq.text"></div>
                    </div>
                </div>
            </div>
        </v-collapse-wrapper>
    </div>
</template>

<script>
    export default {
        props: ['contentfaqs'],
        name: "content-related-faq",
        data: function () {
            return {
                currentItem: null
            }
        },
        methods: {
            switchIconClass: function (e) {
                let target = e.target;
                if (target) {
                    if (target.classList.contains('glyphicon')) {
                        this.switchClass(target);
                    } else {
                        if (target.classList.contains('panel-title')) {
                            let icon = target.getElementsByTagName('i')[0];
                            this.switchClass(icon);
                        } else if(target.classList.contains('title')) {
                            this.switchClass(target.nextElementSibling);
                        }
                    }
                }
            },
            switchClass: function (icon) {
                switch (icon.getAttribute('class')) {
                    case "glyphicon glyphicon-plus":
                        if (this.currentItem !== null) {
                            this.currentItem.setAttribute("class", "glyphicon glyphicon-plus");
                        }
                        icon.setAttribute("class", "glyphicon glyphicon-minus");
                        this.currentItem = icon;
                        break;
                    case "glyphicon glyphicon-minus":
                        icon.setAttribute("class", "glyphicon glyphicon-plus");
                        this.currentItem = icon;
                        break;
                }
            }
        }
    }
</script>

<style scoped>
    .panel {
        background-color: initial;
        border: none;
        box-shadow: none;
        border-bottom: 1px solid #ddd;
        margin-bottom: 0;
        padding: 10px 0;
        border-radius: 0;
    }

    .panel-heading {
        padding: 15px 0;
        border: none;
    }

    .panel-body {
        padding-left: 0;
        padding-right: 0;
    }

    .panel-title {
        position: relative;
        text-transform: uppercase;
    }

    .glyphicon {
        color: #7DBB97;
        position: absolute;
        right: 0;
        top: 0;
        border: 1px solid;
        border-radius: 50%;
        padding: 7px 6px 7px 7px;
    }

    .glyphicon.glyphicon-minus {
        padding: 7px 7px 7px 6px;
    }

    .title {
        font-size: 18px;
        letter-spacing: 0.75px;
    }

</style>
